import React, { useMemo } from 'react';
import { HeyYabbleCountStepTableRowCodeFramesStyle as S } from './HeyYabbleCountStepTableRowCodeFrames.style';
import { useHeyYabbleCountStepBLoC } from '../../../../HeyYabbleCountStep.bloc';
import { useObservableState } from 'observable-hooks';
import { Text } from 'components/Text/Text';
import { PTooltip } from 'components/prime/PTooltip/PTooltip';

export const HeyYabbleCountStepTableRowCodeFrames: React.FC<{
  idCol: number;
  recommendedCodeframeId?: number | null;
  recommendedPipelineId?: number | null;
  isChecked: boolean;
}> = ({ idCol, recommendedCodeframeId, isChecked, recommendedPipelineId }) => {
  const { $adminCodeframes, $pipelines, handleChangeCodeFrameId } = useHeyYabbleCountStepBLoC();
  const adminCodeframes = useObservableState($adminCodeframes, []);
  const pipelines = useObservableState($pipelines, []);

  const selectedPipeline = useMemo(() => {
    return pipelines.find((p) => p.id === recommendedPipelineId);
  }, [pipelines, recommendedPipelineId]);

  const isDisabled = useMemo(() => {
    return !isChecked || !selectedPipeline?.allowsCodeframe;
  }, [isChecked, selectedPipeline]);

  return (
    <S.Dropdown
      value={recommendedCodeframeId}
      optionValue="id"
      optionLabel="name"
      options={adminCodeframes}
      placeholder="Select a codeframe"
      onChange={(e) => handleChangeCodeFrameId(idCol, e.target.value)}
      disabled={isDisabled}
      itemTemplate={(d) => (
        <Text fit="space" ellipsis className={`codeframe-list-item-${d?.id}`}>
          {d?.name}
          <PTooltip target={`.codeframe-list-item-${d?.id}`} position="right" content={d?.name} />
        </Text>
      )}
      data-testid="dropdown-map-step-select-codeframe"
    />
  );
};
